<template>
  <div>
    <!-- 顶部导航栏 -->
    <div class="header" id="header">
      <div></div>
      <div class="logos" id="logos">
        <div class="logoimg" id="logoimg"></div>
      </div>
      <div><h3 class="logoh" id="logoh"></h3></div>
      <div>
        <div class="navigation-up" id="navigation-up">
          <div class="navigation-inner" id="navigation-inner">
            <div class="navigationv3" id="navigationv3">
                <ul name="topul">
                  <!-- 默认被选中项 -->
                  <li
                    :class="i.url == route.path ? 'selectinpage' : ''"
                    :id="i.url == route.path ? 'selectinpage' : ''"
                    v-for="i in nevigatelist"
                    :_t_nav="i.nav"
                    name="topli"
                  >
                    <h2 name=toph2>
                      <a name="topa" :href="i.url">{{ i.label }}</a>
                    </h2>
                  </li>
                </ul>
            </div>
          </div>
        </div>
        <!-- <div class="navigation-down" id="navigation-down">
          <div
            v-for="i in navdetails"
            :id="i.id"
            :class="
              i.id == 'product'
                ? ['nav-down-menu', 'menu-1']
                : ['nav-down-menu', 'menu-3', 'menu-1']
            "
            style="display: none"
            :_t_nav="i.id"
          >
            <div class="navigation-down-inner">
              <dl
                v-for="item in i.childrenlist"
                :style="item.id == '1' ? { 'margin-left': i.leftlength } : ''"
              >
                <dt v-if="item.label != ''">{{ item.label }}</dt>
                <dd v-for="y in item.hreflist">
                  <a class="link" href="#">{{ y.label }}</a>
                </dd>
              </dl>
            </div>
          </div>
        </div> -->
      </div>
      <div></div>
      <div class="login" id="login"><a class="denglu" id="denglu" href="/login">报名/登录</a></div>
    </div>
    <!-- 主体部分 -->
    <div class="bodys" id="bodys">
      <!-- 竞赛介绍大图 -->
      <div class="bigimg" id="bigimg">
        <h1 class="bigimg_1" id="bigimg_1"></h1>
      </div>
      <!-- 居中 -->
        <router-view></router-view>
    </div>
    <!-- 底部 -->
    <div class="footer" id="footer">
      <p class="top">版权所有:全国大学生智能汽车竞赛组织委员会秘书处</p>
      <!-- <p class="middle">联系地址:xx省xx市xx路xxx号 邮编:xxxxxx</p> -->
      <p class="top">
       备案号:湘ICP备2024087133号-1
      </p>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      isPC: this.isPCNot(),
      /* 导航标题 */
      nevigatelist: [
        {
          id: "1",
          nav: "home",
          url: "/",
          label: "首页",
        },
        {
          id: "2",
          nav: "product",
          url: "/about",
          label: "关于大赛",
        },
        {
          id: "3",
          url: "/newsinfo",
          nav: "wechat",
          label: "竞赛动态",
        },
        {
          id: "4",
          nav: "solution",
          label: "往届赛事",
          url: "/precompetitions",
        },
        {
          id: "5",
          nav: "cooperate",
          url: "/learn",
          label: "学习专区",
        },
      ],
      styledata:[],
    };
  },
  methods: {
    changestyle(){
			//如果是安卓端
			console.log(this.isPC);
      var navigation_v3=document.getElementById("navigationv3").style; 
      if(this.isPC==false){
        //顶部的样式
        var headerstyle = document.getElementById("header").style; 
        headerstyle.height="4vh";
        headerstyle.gridTemplateColumns="0% 7% 20% 60% 0% 13%"
        var logoimg=document.getElementById("logoimg").style; 
        logoimg.height="3.5vh";
        var logohstyle=document.getElementById("logoh").style; 
        logohstyle.fontSize="0.5em"
        logohstyle.top="0%"
        logohstyle.paddingTop="1.5vh"
        logohstyle.marginLeft="1px"

        var navigation=document.getElementById("navigation-inner").style; 
        navigation.width="100%";
        navigation.height="4vh";
        navigation.height="4vh"
        navigation_v3.marginLeft="0px"
        navigation_v3.height="4vh"
        var topa=document.getElementsByName('topa');
        for (var i=0;i<topa.length;i++){
          topa[i].style.padding="0 5px";
          topa[i].style.height="4vh";
          topa[i].style.fontSize="0.5em";
          topa[i].style.marginTop="1.2em";
        }
        var toph2=document.getElementsByName('toph2');
        for (var i=0;i<toph2.length;i++){
          toph2[i].style.height="4vh";
        }
        var topli=document.getElementsByName('topli');
        for (var i=0;i<topli.length;i++){
          topli[i].style.height="4vh";
        }
        var topul=document.getElementsByName('topul');
        for (var i=0;i<topul.length;i++){
          topul[i].style.height="4vh";
        }
        //登录
        var denglu=document.getElementById("denglu").style; 
        denglu.fontSize="0.5em"

        var login=document.getElementById("login").style; 
        login.paddingTop="10%";
        login.height="4vh";

        var bigimg=document.getElementById("bigimg").style; 
        bigimg.height="12vh"

        var bigimg_1=document.getElementById("bigimg_1").style; 
        bigimg_1.fontSize="1.5em"
        bigimg_1.top="9%"
        bigimg_1.textShadow="0 1 #f9f4f4" 

      }
      else{
				navigation_v3.marginLeft="10em"
			}
		},
    //判断是否为PC
    isPCNot() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
              flag = false;
              break;
          }
      }
      return flag;
    },
    getallcss(){
			let config = {
				headers: { "Content-Type": "multipart/form-data" }
			};
			//添加请求头
			let param = new FormData(); //创建form对象
			this.$axios.post("http://82.157.23.29:5000/getAllpageDisplay", param, config)
			.then((response) =>{
				this.csscont=response.data;
				for (var i=0;i<this.csscont.length;i++){
					// alert(this.csscont[i].id)
					var style = document.getElementById(this.csscont[i].id).style; 
					style.width=this.csscont[i].width;
					style.height=this.csscont[i].height;
					style.display=this.csscont[i].display;
					style.gridTemplateColumns =this.csscont[i].column;
					style.gridTemplateRows =this.csscont[i].row;
					style.position =this.csscont[i].position;
					style.top=this.csscont[i].top;
					style.bottom=this.csscont[i].bottom;
					style.right=this.csscont[i].right;
					style.left=this.csscont[i].left;
				}
        this.changestyle();
			});
		},
		getallstyle(){
			let config = {
				headers: { "Content-Type": "multipart/form-data" }
			};
			//添加请求头
			let param = new FormData(); //创建form对象
			this.$axios.post("http://82.157.23.29:5000/getAllpageStyle", param, config)
			.then((response) =>{
				this.styledata=response.data;
        console.log(this.styledata);
				for (var i=0;i<this.styledata.length;i++){
          let styid=this.styledata[i].id;
          if(styid=="selectinpage"){
            let rotpath=this.$route.path;
            if(rotpath!="/" && rotpath!="/about" && rotpath!="/newsinfo" && rotpath!="/precompetitions" && rotpath!="/learn"){
              continue;
            }
          }
					var style2 =document.getElementById(this.styledata[i].id).style;
					var element=document.getElementById(this.styledata[i].id);
					if(this.styledata[i].bgimg!=""){
						style2.backgroundImage="url("+this.styledata[i].bgimg+")";
					}
					else{
						if(this.styledata[i].bgcolor!="rgba(255, 255, 255, 0)"){
							style2.background=this.styledata[i].bgcolor;
					  }
					}
					style2.fontSize=this.styledata[i].contsize;
					style2.fontfamily=this.styledata[i].contfamily;
					if(this.styledata[i].cont!="" ){
						if(this.styledata[i].cont!="undefined")
						{
							element.innerHTML=this.styledata[i].cont;
						}				  
					}
					if(this.styledata[i].contcolor!="rgba(255, 255, 255, 0)"){
						style2.color=this.styledata[i].contcolor;
					}
					if(this.styledata[i].url!=undefined){
						if(this.styledata[i].url!=""){
					    element.setAttribute('href', this.styledata[i].url);
                        element.setAttribute('target', '_blank');
						}
					}
					// style2.fontSize=this.styledata[i].titlesize;
					// style2.background=this.styledata[i].bgcolor;

				}
        this.getallcss();
			});
		},
  },
  created() {
    // console.log(this.$route.path);
    // if(this.$route.path=="/newsdetail"){
    //   this.$route.path="/newsinfo"
    // }
    this.getallstyle();
  },
  computed: {},
  mounted() {
    jQuery(document).ready(function () {
      var qcloud = {};
      $("[_t_nav]").hover(
        function () {
          var _nav = $(this).attr("_t_nav");
          clearTimeout(qcloud[_nav + "_timer"]);
          qcloud[_nav + "_timer"] = setTimeout(function () {
            $("[_t_nav]").each(function () {
              $(this)[
                _nav == $(this).attr("_t_nav") ? "addClass" : "removeClass"
              ]("nav-up-selected");
            });
            $("#" + _nav)
              .stop(true, true)
              .slideDown(200);
          }, 150);
        },
        function () {
          var _nav = $(this).attr("_t_nav");
          clearTimeout(qcloud[_nav + "_timer"]);
          qcloud[_nav + "_timer"] = setTimeout(function () {
            $("[_t_nav]").removeClass("nav-up-selected");
            $("#" + _nav)
              .stop(true, true)
              .slideUp(200);
          }, 150);
        }
      );
    });
    
  },
};
</script>
<script setup>
// import { ref } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();
</script>
<style>
:-webkit-scrollbar {
  width: 5px;
  height: 14px;
}

::-webkit-scrollbar-thumb {
  background-color: #b6b6b6;
}
</style>
<style scoped>
html {
  font-size: 62.5%;
  font-family: "helvetica neue", tahoma, arial, "hiragino sans gb", "Simsun",
    sans-serif;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
button,
textarea,
p,
blockquote,
hr {
  margin: 0;
  padding: 0;
}

body {
  line-height: 1.333;
  font-size: 12px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-family: arial, "hiragino sans gb", "microsoft yahei", "Simsun",
    sans-serif;
}

li {
  list-style: none;
}

a:link,
a:visited {
  text-decoration: none;
}

.header {
  position: relative;
  z-index: 100;
  height: 100%;
}

.header .navigation-inner {
  margin: 0 auto;
  width: 980px;
  position: relative;
}

.navigation-up {
  height: 60px;
}

.navigation-up .navigationv3 {
  float: left;
  margin-left: 10em;
}

.navigation-up .navigationv3 ul {
  float: left;
}

.navigation-up .navigationv3 li {
  float: left;
  margin: auto;
  color: #fff;
}

.navigation-up .navigationv3 .nav-up-selected {
  background: #4480d9;
}

.navigation-up .navigationv3 .selectinpage {
}

.navigation-up .navigationv3 li h2 {
  font-weight: normal;
  padding: 0;
  margin: 0;
}

.navigation-up .navigationv3 li h2 a {
  padding: 0 25px;
  color: #fff;
  display: inline-block;
  margin-top:2vh;
  height: 4.8vh;
  font-family: "microsoft yahei";
  top:0;left:0;right:0;bottom:0;
}

.navigation-down {
  position: absolute;
  top: 60px;
  left: 0px;
  width: 100%;
}

.navigation-down .nav-down-menu {
  width: 100%;
  margin: 0;
  background: #5c6267;
  position: absolute;
  top: 0px;
}

.navigation-down .nav-down-menu .navigation-down-inner {
  margin: auto;
  width: 80%;
  position: relative;
}

.navigation-down .nav-down-menu dl {
  float: left;
  margin: 18px 80px 18px 0;
}

.navigation-down .menu-1 dl {
  margin: 20px 80px 25px 0;
}

.navigation-down .menu-1 dt {
  font: normal 16px "microsoft yahei";
  color: #f4f4f4;
  padding-bottom: 10px;
  border-bottom: 1px solid #f1f3f6;
  margin-bottom: 10px;
}

.navigation-down .menu-1 dd a {
  color: #fff;
  font: normal 14px/30px "microsoft yahei";
}

.navigation-down .menu-1 dd a:hover {
  color: #60aff6;
}

.navigation-down .menu-2 dd a,
.navigation-down .menu-3 dd a {
  color: rgba(255, 255, 255, 1);
  font: normal 16px "microsoft yahei";
}

.bigimg {
  height: 25vh;
  background-color: transparent;
  /*no-repeat:背景图将不会被重复*/
  background-size: cover;
  /*背景图片放大到适合元素容器的尺寸，图片比例不变.背景图像的某些部分可能无法显示在背景定位区域中。*/
}

.news {
  height: 85vh;
}

.newsinfo {
  display: grid;
  grid-template-columns: 5% 50% 0% 45%;
}

.competition {
  height: 70vh;
}



.study {
  height: 50vh;
  background-color: #7c7ca1;
}

.review {
  height: 90vh;
}

.qs {
  height: 75vh;
}

.footer {
  height: 30vh;
  background-color: #586885;text-align: center;
}

.demo-tabs >>> .el-tabs__item {
  font-size: 1.07em;
  font-family: "黑体";
}



.bigimg_1 {
  font: 800 70px/1 "Source Sans Pro", Arial, sans-serif;
  background: transparent;
  text-transform: uppercase;
  color: #ffffff;
  text-align: center;
  position: absolute;
  top: 15%;
  width: 97%;

  text-shadow: 0 1px 0 hsl(173, 11%, 85%), 0 2px 0 hsl(0, 0%, 84%),
    0 3px 0 hsl(174, 5%, 70%), 0 4px 0 hsl(174, 5%, 66%),
    0 5px 0 hsl(174, 5%, 64%), 0 6px 0 hsl(174, 5%, 62%),
    0 7px 0 hsl(174, 5%, 61%), 0 8px 0 hsl(174, 5%, 60%),
    0 0 5px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.2),
    0 3px 5px rgba(0, 0, 0, 0.2), 0 5px 10px rgba(0, 0, 0, 0.2),
    0 10px 10px rgba(0, 0, 0, 0.2), 0 20px 20px rgba(0, 0, 0, 0.3);
}

.footer {
  background-color: #444444;
  height: 100%;
  width: 100%;
  padding: 2vh 0;
}

.footer p {
  color: white;
  font-size: 16px;
  display: block;
  line-height: 38px;
}
.arrange {
  height: 54vh;
}
.bodys {
  background-color: #f9f9f9;
}
.ogh2 {

}
.logoimg {
  position: relative;
  width: 100%;
  height: 90%;
  top: 5%;
  /*no-repeat:背景图将不会被重复*/
  background-size: 100% 100%;
}

.header {
  position: relative;
  z-index: 100;
  height: 100%;
  width: 100%;
  display: grid;
 grid-template-columns: 3% 3% 11% 68% 8% 7%;
}

.logoh {
  position: relative;
  padding-top:10%;
  color: white;
  margin-left: 10px;
}
.logos {
  display: grid;
}
a:hover,
a:link,
a:visited,
a:active,
a:focus {
  color: ghostwhite;
  text-decoration: none;
}
.login {
  position: relative;
  text-decoration:black;
	padding-top:17%;
}
.denglu{
		color:white
}
.newscontain {
  display: grid;
  grid-template-columns: 70% 30%;
  height: 120vh;
}

</style>
